import React, { Fragment, useState } from "react";
import { Route, Routes } from "react-router-dom";
import Login from "./features/login/Login";
import { ToastContainer } from "react-toastify";
import { MainControl } from "./features/control/Control";
import { AnomalyRegistration } from "./features/anomalyRegistration/anomalyRegistration";
import { Container, Nav } from "react-bootstrap";
import { DbTable } from "./features/dbTable/dbTable";
import Scanner from "./features/qrScan/qrScan";
import { Equipment } from "./features/equipment/equipment";
import { ManualEquipment } from "./features/equipment/manulaEquipment";
import { ScreenShot } from "./features/ScreenShot/ScreenShot";
import { AnomalyReport } from "./features/anomalyReport/anomalyReport";
import { Support } from "./features/support/Support";
import { logoutUser } from "./features/login/loginApi";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { resetEditor } from "./features/dbTable/dbTablSlice";
import { Link, useNavigate } from "react-router-dom";
import { resetAllEquipment } from "./features/equipment/equiplmentSlice";
import { resetAnomaly } from "./features/anomalyRegistration/anomalySlice";
import { useLocation } from "react-router-dom";
import { setToken } from "./features/login/loginSlice";
import { getUser } from "./features/userProfile/userApi";
/*

AiOutlineFullscreen

if (!isEmpty(localStorage.getItem("token"))) {
    store.dispatch(setToken(localStorage.getItem("token")));
  }
  if (!isEmpty(localStorage.getItem("user"))) {
    const user = JSON.parse(localStorage.getItem("user"));
    store.dispatch(setCurrentUser(user, ""));
  }
*/
export function App(props) {
  const log = useSelector((state) => state.login)
  const dispatch = useDispatch()
  const history = useNavigate();
  const location = useLocation();
  var exitLink = (<Fragment></Fragment>)
  var profileLink = (<Fragment></Fragment>)
  function onReturnProfile() {
    dispatch(resetAllEquipment())
    dispatch(resetEditor())
    dispatch(resetAnomaly())
  }

  let localToken = null
  var navbar = (<Fragment></Fragment>)
  var navProp = "navbar navbar-expand bg-light navbar-light mb-3 px-0 py-3 col-xl-5 col-lg-6 mx-auto"


  try {
    localToken = JSON.parse(localStorage.getItem("token"))
  } catch (e) {
  }

  if (!localToken){
    dispatch(setToken(null))
  }

  if (localToken && localToken.length > 0) {
    dispatch(setToken(localToken))
    dispatch(getUser(localToken))
    profileLink = (<Fragment><Nav.Link as={Link} to="/control" onClick={(e) => onReturnProfile()}>Профиль</Nav.Link></Fragment>)
    exitLink = (<Fragment><Nav.Link href="login" onClick={() => dispatch(logoutUser(log))}>Выйти</Nav.Link></Fragment>)

    if (location.pathname == "/db") {
      navProp = "navbar navbar-expand bg-light navbar-light mb-3 px-0 py-3 col-xl-12 col-lg-6 mx-auto"
    }

    navbar = (<Fragment>
      <nav className={navProp}>
        <Container>
          <Link to={"/"} className="navbar-brand">{log.pageName}</Link>
          <div className="navbar-nav">
            <Link className="nav-link" to={"/control"} onClick={(e) => onReturnProfile()}><i className="fa-solid fa-user fa-lg"></i></Link>
            <a className="nav-link" >
              <i className="fa-lg fa-solid fa-chevron-left" onClick={() => history(-1)}></i>
            </a>
          </div>
        </Container>
      </nav>

    </Fragment>)
  }
  return (
    <Fragment>
      {navbar}
      <Container className="mb-3">
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <Routes >
          <Route path="control" element={<MainControl />} />
          <Route path="login" element={<Login />} />
          <Route path="anomaly" element={<AnomalyRegistration />} />
          <Route path="anomaly-editor" element={<AnomalyRegistration />} />
          <Route path="anomaly-chart" element={<AnomalyReport />} />
          <Route path="db" element={<DbTable />} />
          <Route path="scan" element={<Scanner />}></Route>
          <Route path="equipment" element={<Equipment />}></Route>
          <Route path="manual" element={<ManualEquipment />}></Route>
          <Route path="screenshot" element={<ScreenShot />}></Route>
          <Route path="support" element={<Support />}></Route>
          <Route
            path="*"
            element={<MainControl />}
          />

        </Routes>
      </Container>
    </Fragment>
  );


}

export default App;
